import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

// 7-column month grid with two highlighted cells standing in for events.
const HIGHLIGHTED = [7, 13];

export const CalendarThumbnail = () => (
  <Box w="full">
    {/* day header */}
    <Flex gap="2px" mb="3px">
      {Array.from({ length: 7 }).map((_, i) => (
        <Box
          bg={BAR}
          borderRadius="1px"
          flex={1}
          h="4px"
          key={i}
          opacity={0.7}
        />
      ))}
    </Flex>
    {/* grid rows */}
    <Flex flexWrap="wrap" gap="2px">
      {Array.from({ length: 21 }).map((_, i) => (
        <Box
          bg={HIGHLIGHTED.includes(i) ? ACCENT : BAR}
          borderRadius="2px"
          h="8px"
          key={i}
          opacity={HIGHLIGHTED.includes(i) ? 0.6 : 0.5}
          w="calc(14.28% - 2px)"
        />
      ))}
    </Flex>
  </Box>
);
